import React from "react";
import moment from "moment";
import { Table, Typography } from "antd";
import { useIntl } from "react-intl";
import { getManualItems } from "../../../components/print/printSections/diary";
const { Text } = Typography;
const WorkPlan = (props) => {
  const { employeeEvents, print, manualEvents } = props;
  const intl = useIntl();
  let tableData = [];
  let durations = {};
  if (employeeEvents && employeeEvents.length > 0) {
    employeeEvents.forEach((item, i) => {
      const startDate = moment()
        .startOf("day")
        .set("minute", item.start_time_minutes);
      const end = moment()
        .startOf("day")
        .set("minute", item.duration_minutes + item.start_time_minutes);
      const timeframe = end.format("HH:mm") + "-" + startDate.format("HH:mm");
      if (!tableData[0]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[0][item.weekday]) {
        tableData[0][item.weekday] = timeframe;
      } else if (!tableData[1]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[1][item.weekday]) {
        tableData[1][item.weekday] = timeframe;
      } else if (!tableData[2]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[2][item.weekday]) {
        tableData[2][item.weekday] = timeframe;
      } else if (!tableData[3]) {
        tableData.push({
          [item.weekday]: timeframe,
        });
      } else if (!tableData[3][item.weekday]) {
        tableData[3][item.weekday] = timeframe;
      }
      durations[item.weekday] = durations[item.weekday]
        ? durations[item.weekday] + item.duration_minutes / 60
        : item.duration_minutes / 60;
      durations["total"] = durations["total"]
        ? durations["total"] + item.duration_minutes / 60
        : item.duration_minutes / 60;
    });
  }

  if (durations["total"]) {
    let rounded = {};
    Object.keys(durations).map(
      (key) => (rounded[key] = Math.round(durations[key] * 100) / 100)
    );
    tableData.push(rounded);
  }

  const columns = [
    {
      title: moment.weekdays()[0],
      dataIndex: "0",
      key: "0",
    },
    {
      title: moment.weekdays()[1],
      dataIndex: "1",
      key: "1",
    },
    {
      title: moment.weekdays()[2],
      dataIndex: "2",
      key: "2",
    },
    {
      title: moment.weekdays()[3],
      dataIndex: "3",
      key: "3",
    },
    {
      title: moment.weekdays()[4],
      dataIndex: "4",
      key: "4",
    },
    {
      title: moment.weekdays()[5],
      dataIndex: "5",
      key: "5",
    },
    {
      title: moment.weekdays()[6],
      dataIndex: "6",
      key: "6",
    },
    {
      title: intl.formatMessage({
        id: "app.work_diary_print.total",
      }),
      dataIndex: "total",
      key: "7",
    },
  ];

  const manualData = getManualItems(manualEvents);

  const schedulingColumns = [
    {
      dataIndex: "sunday",
      key: "sunday",
      width: "14.28%",
    },
    {
      dataIndex: "monday",
      key: "monday",
      width: "14.28%",
    },
    {
      dataIndex: "tuesday",
      key: "tuesday",
      width: "14.28%",
    },
    {
      dataIndex: "wednesday",
      key: "wednesday",
      width: "14.28%",
    },
    {
      dataIndex: "thursday",
      key: "thursday",
      width: "14.28%",
    },
    {
      dataIndex: "friday",
      key: "friday",
      width: "14.28%",
    },
    {
      dataIndex: "satuarday",
      key: "satuarday",
      width: "14.28%",
    },
  ];
  return tableData && tableData.length > 0 ? (
    <div>
      {print ? (
        <div className="vertical_spacer" />
      ) : (
        <div className="vertical_spacer high" />
      )}

      <Table
        bordered
        columns={columns}
        dataSource={tableData.map((i, index) => ({ ...i, key: index }))}
        pagination={false}
        size="small"
        rowKey={(record) => record.key}
      />
    </div>
  ) : (
    <div style={{}}>
      <Text style={{ paddingTop: "10px" }}>מועדי שיבוצים</Text>
      <Table
        showHeader={false}
        bordered
        columns={schedulingColumns}
        dataSource={manualData.map((i, index) => ({ ...i, key: index }))}
        pagination={false}
        size="small"
        rowKey={(record) => record.key}
      />
    </div>
  );
};

export default WorkPlan;
